var map = {
	"./ArchitectureArticleFull.vue": [
		9868,
		868
	],
	"./Bedroom2ArticleFull.vue": [
		1254,
		254
	],
	"./BedroomArticleFull.vue": [
		7263,
		263
	],
	"./BuildingArticleFull.vue": [
		635,
		635
	],
	"./KitchenArticleFull.vue": [
		1416,
		416
	],
	"./PlanningKitchenArticleFull.vue": [
		8183,
		183
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5754;
module.exports = webpackAsyncContext;